import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { Button, Tag, Icon } from '@blueprintjs/core';
import numbro from 'numbro';
import { has } from 'lodash';
import classNames from 'classnames';
import axios from 'axios';
import { AppToaster } from 'components/Toaster';

import { getCameras } from 'actions/nvr';

class Cameras extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cameras: {},
    };
  }

  componentDidMount() {
    const { dispatch, nvr } = this.props;
    dispatch(getCameras(nvr));
    this.setState({ cameras: {} });
  }

  componentDidUpdate(prevProps) {
    const { dispatch, nvr } = this.props;
    if (nvr.id !== prevProps.nvr.id) {
      dispatch(getCameras(nvr));
      // this.setState({cameras: {}});
    }
  }

  @autobind
  handlePing(camera_id, camera_name) {
    const { nvr } = this.props;
    // const { cameras } = this.state;
    this.setState(({ cameras }) => (
      {
        cameras: {
          ...cameras,
          [camera_id]: {
            ...cameras[camera_id],
            pinging: true,
          },
        },
      }
    ));
    axios.get(`https://${nvr.hostname}/nvr/v1/cameras/${camera_id}?ping=true&record_check=1d`, {
      headers: {
        Authorization: `Bearer ${nvr.access_token}`,
      },
    })
      .then((response) => {
        if (response.data.content.ping) {
          const ms = response.data.content.ping * 1000;
          AppToaster.show({
            icon: 'tick',
            message: (
              <span>
                <strong>
                  {camera_name}
                </strong>
                : Pinged&nbsp;
                <em>{`${numbro(Math.abs(ms)).format('0,0[.00]')}ms`}</em>
              </span>
            ),
            intent: 'success',
          });
          this.setState(({ cameras }) => (
            {
              cameras: {
                ...cameras,
                [camera_id]: {
                  ...response.data.content,
                  pinging: false,
                },
              },
            }
          ));
        } else {
          AppToaster.show({
            icon: 'cross',
            message: (
              <span>
                <strong>
                  {camera_name}
                </strong>
                :&nbsp;
                Failed to contact device.
              </span>
            ),
            intent: 'danger',
          });

          this.setState(({ cameras }) => (
            {
              cameras: {
                ...cameras,
                [camera_id]: {
                  ...cameras[camera_id],
                  pinging: false,
                },
              },
            }
          ));
        }
      })
      .catch((error) => {
        const isTimeout = (error.response || {}).status === 504;
        const respData = ((error.response || {}).data) || {};
        const errMessage = (respData.result || {}).errorMessage || 'unknown';
        // if (isTime)

        AppToaster.show({
          icon: isTimeout ? 'cross' : 'error',
          message: (
            <span>
              <strong>
                {camera_name}
              </strong>
              :&nbsp;
              {isTimeout ? 'Failed to contact device.' : `An error occured: ${errMessage}`}
            </span>
          ),
          intent: 'danger',
        });

        this.setState(({ cameras }) => (
          {
            cameras: {
              ...cameras,
              [camera_id]: {
                ...cameras[camera_id],
                pinging: false,
              },
            },
          }
        ));
      });
  }

  @autobind
  renderCamera(xcamera) {
    const { cameras } = this.state;
    const camera = has(cameras, xcamera.id) ? {
      ...xcamera,
      ...cameras[xcamera.id],
    } : xcamera;
    let pingIntent = camera.ping ? 'success' : 'danger';
    pingIntent = camera.pinging ? 'warning' : pingIntent;
    return (
      <tr key={camera.id}>
        <td><Tag round intent="primary">{camera.id}</Tag></td>
        <td>{camera.name}</td>
        <td className="has-text-centered"><Icon icon="symbol-circle" intent={camera.enabled ? 'success' : 'danger'} /></td>
        <td className="has-text-centered"><Icon icon="symbol-circle" intent={camera.recording ? 'success' : 'danger'} /></td>
        <td className="has-text-centered">
          <Tag intent={pingIntent} round>
            {camera.ping ? `${numbro(Math.abs(camera.ping * 1000)).format('0,0[.00]')}ms` : (<span>&times;</span>)}
          </Tag>
        </td>
        <td className="has-text-right">{camera.last_ip}</td>
        <td>{camera.failed}</td>
        <td className="has-text-right">
          <Button
            small
            intent="primary"
            icon="pulse"
            onClick={() => this.handlePing(camera.id, camera.name)}
            loading={camera.pinging}
          >
            Ping
          </Button>
        </td>
      </tr>
    );
  }

  render() {
    const { cameras } = this.props;
    return (
      <table className={classNames('bp3-html-table bp3-html-table-striped bp3-interactive', { 'bp3-skeleton': !!cameras.pending })}>
        <thead>
          <tr>
            <td>ID</td>
            <td>Name</td>
            <td className="has-text-centered">Enabled</td>
            <td className="has-text-centered">Recording</td>
            <td className="has-text-centered">Ping</td>
            <td className="has-text-right">IP</td>
            <td>Failed</td>
            <td />
          </tr>
        </thead>
        <tbody>

          {// eslint-disable-next-line max-len
          }
          {(cameras.data || [])
            .map(this.renderCamera)}

        </tbody>
      </table>
    );
  }
}

Cameras.propTypes = {
  nvr: PropTypes.object,
  cameras: PropTypes.array,
  dispatch: PropTypes.func,
};

export default connect(state => ({
  cameras: state.nvrCameras,
}))(Cameras);
